import { Routes, Route } from 'react-router-dom';

// Auth Context
import { AdminAuthProvider } from './context/adminAuthContext';

// Protected Routes
// import AdminProtectedRoutes from './routes/AdminProtectedRoutes';

// Admin Layout
import AdminLayout from './layouts/AdminLayout';

// Auth
import Login from './pages/auth/admin/Login';

// Pages 
import Dashboard from './pages/admin/Dashboard';
import ManageStudent from './pages/admin/ManageStudent';
import ManageTutor from './pages/admin/ManageTutor';
import Offices from './pages/admin/Offices';
import Courses from './pages/admin/Courses';
import Payment from './pages/admin/Payments';
import TutorCourses from './pages/admin/TutorCourses';
import Reviews from './pages/admin/Reviews';
import Assignment from './pages/admin/Assignment';
import Withdrawals from './pages/admin/Withdrawals';
import Classes from './pages/admin/Classes';
import Settings from './pages/admin/Settings';
import OtherSettings from './pages/admin/OtherSettings';
import ManageCohub from './pages/admin/ManageCohub';
import Enrollments from './pages/admin/Enrollments';
import Messages from './pages/admin/Messages';
import Chat from './pages/admin/Chat';
import GroupClass from './pages/admin/GroupClass';
import SubscriptionPlans from './pages/admin/SubscriptionPlans';
import StudentPreferences from './pages/admin/StudentPreferences';
import VettingRequests from './pages/admin/VettingRequests';


const AdminApp = () => {
  return (
    <AdminAuthProvider>
      <Routes>
        {/* Auth routes - these will be at /Admin/login etc. */}
        <Route path="login" element={<Login />} />

        {/* Protected routes with layout */}
        <Route 
          element={
            // <AdminProtectedRoutes role="admin">
              <AdminLayout />
            // </AdminProtectedRoutes>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="students" element={<ManageStudent />} />
          <Route path="tutors" element={<ManageTutor />} />
          <Route path="offices" element={<Offices />} />
          <Route path="courses" element={<Courses />} />
          <Route path="tutor-courses" element={<TutorCourses />} />
          <Route path="reviews" element={<Reviews />} />
          <Route path="withdrawals" element={<Withdrawals />} />
          <Route path="classes" element={<Classes />} />
          <Route path="assignments" element={<Assignment />} />
          <Route path="payments" element={<Payment />} />
          <Route path="enrollments" element={<Enrollments />} />
          <Route path="settings" element={<Settings />} />
          <Route path="other-settings" element={<OtherSettings />} />
          <Route path="cohubs" element={<ManageCohub />} />
          <Route path="messages" element={<Messages />} />
          <Route path="group-class" element={<GroupClass />} />
          <Route path="subscription-plans" element={<SubscriptionPlans />} />
          <Route path="student-preferences" element={<StudentPreferences />} />
          <Route path="vetting-requests" element={<VettingRequests />} />
          <Route path="messages/:tutorId/:studentId" element={<Chat />} />
        </Route>
      </Routes>
    </AdminAuthProvider>
  );
};

export default AdminApp;

// Admin